import { Table, mergeClasses } from '@fluentui/react-components';
import type { HTMLAttributes } from 'react';
import type { ContextModel } from '../../hooks/_shared/context.js';
import { useStyles } from './styles.js';

export function ResizableTable<TData>(
    props: HTMLAttributes<HTMLDivElement> & {
        context?: ContextModel<TData>;
    }
) {
    const styles = useStyles();

    const hasInitialized = props.context?.hasInitialized;
    const maxWidth = props.context?.maxWidth;
    const padContainerValue = props.context?.padContainerValue;
    const containerRef = props.context?.containerRef;
    const tableRef = props.context?.tableRef;

    return (
        <div>
            <div
                style={{
                    paddingBottom: padContainerValue,
                    maxWidth: maxWidth,
                }}
            >
                <div
                    ref={containerRef}
                    className={mergeClasses(styles.container, !hasInitialized && styles.containerUninitialized)}
                >
                    <Table ref={tableRef} className={styles.table}>
                        {props.children}
                    </Table>
                </div>
            </div>
        </div>
    );
}
